import { TranslateService } from '@ngx-translate/core';
import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { damoAuthConfig, DamoAuthConfig } from './damoauth.config';
import { getApp, getApps, initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, indexedDBLocalPersistence, initializeAuth, provideAuth } from '@angular/fire/auth';
import { getFunctions, provideFunctions } from '@angular/fire/functions';
import { provideHttpClient } from '@angular/common/http';
import { browserLocalPersistence } from '@firebase/auth';
import { I18N_LANG } from './i18n';

export function provideDamoAuth(config: DamoAuthConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: damoAuthConfig, useValue: config },
    provideAppInitializer(() => {
      const translate = inject(TranslateService);
      Object.entries(I18N_LANG).forEach(([lang, translation]) => translate.setTranslation(lang, translation, true));
    }),
    provideFirebaseApp(() => {
      if (getApps().length > 0) return getApp();
      const app = initializeApp(config.firebase);
      initializeAuth(app, { persistence: [indexedDBLocalPersistence, browserLocalPersistence] });
      return app;
    }),
    provideAuth(() => getAuth(getApp())),
    provideFunctions(() => getFunctions(getApp(), config.fnsOrigin)),
    provideHttpClient(),
  ]);
}
